import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <div className="shutter-card">
      <Link
        to={`/categories/${item?.slug || item?.slugPath}`}
        className="image img-style d-block"
      >
        <div className="img-layer">
          {/* <img src={cat.img} alt={cat.title} /> */}
          {item?.image && (
            <img src={item?.image} alt="categories" className="lazyload" />
          )}
        </div>
        <div className="shutter-panel panel-left"></div>
        <div className="shutter-panel panel-right"></div>
        <div className="content-layer">
          {/* <div className="corner-number">0{index + 1}</div> */}

          <div className="text-box">
            {/* <span className="cat-subtitle">{cat.subtitle}</span> */}
            {/* <span className="link text-md fw-medium">{item?.name}</span> */}
            <h3>{item.name}</h3>
            <div className="btn-wrapper">
              <Link to="/shop" className="shutter-btn">
                View More Products
              </Link>
            </div>
          </div>
        </div>

        {/* Border effect */}
        <div className="border-trace"></div>
      </Link>
    </div>
  );
}

export default Card;
